import { useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export function useSignOut() {
  const { logout } = useAuth();
  const [open, setOpen] = useState(false);

  const signOut = async () => {
    try {
      const { data } = await api.get("/hrms/me/attendance");
      if (["working", "on_break"].includes(data?.status)) {
        setOpen(true);
        return;
      }
    } catch {}
    logout();
  };

  const dialog = (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent data-testid="signout-clocked-in-dialog">
        <DialogHeader>
          <DialogTitle>You are still clocked in</DialogTitle>
          <DialogDescription>
            Signing out of the app does not clock you out. Your shift timer keeps running until you
            clock out from the attendance card.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => setOpen(false)} data-testid="signout-cancel-button">
            Stay signed in
          </Button>
          <Button
            onClick={() => { setOpen(false); logout(); }}
            className="bg-[#255058] text-white hover:bg-[#1c3d43]"
            data-testid="signout-confirm-button"
          >
            Sign out anyway
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );

  return { signOut, dialog };
}
